import { Table, Column, useServerListApi } from '@2r/frontend-component-library';
import { VmPartnership } from '../model/VmPartnership';

export function FrameListPartnerships() {
    const ColumnNames: Column<VmPartnership>[] = [
        { Name: 'id', Label: 'ID' },
        { Name: 'partner1', Label: 'Partner 1' },
        { Name: 'partner2', Label: 'Partner 2' },
        { Name: 'interface', Label: 'Schnittstelle' },
    ];

    const modul = useServerListApi<VmPartnership>({
        name: 'Partnerschaften',
        path: '/partnerships',
        Columns: ColumnNames,
        embedded: false
    });

    return <Table<VmPartnership> {...modul.defaultTableProps} />;
}